<template>
  <BaseSimpleLayout class="accept-detail">
    <template #title>受注情報詳細</template>
    <template v-if="loadingFlag" #button-area>
      <el-button
        v-if="customerId"
        size="large"
        type="info"
        @click="backCustomerDetail"
      >
        顧客管理情報
      </el-button>
      <el-button size="large" type="info" @click="router.push('/accept')">
        受注一覧
      </el-button>
      <ScreenPermissionGate code="ACCEPT-BTN_EDIT">
        <el-button
          v-if="status === 2"
          size="large"
          type="primary"
          @click="router.push('/accept/create/basic')"
        >
          編集
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="ACCEPT-BTN_REQUEST_SHIPMENT">
        <el-button
          v-if="status === 2 && isShip"
          size="large"
          type="success"
          @click="handleShipRequestClick"
        >
          出荷依頼
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="ACCEPT-BTN_CONFIRM_SHIPMENT_REQUEST">
        <el-button
          v-if="status === 3 && isShip"
          size="large"
          type="success"
          @click="displayConfirmDialog = true"
        >
          出荷依頼確定
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="ACCEPT-BTN_DELETE">
        <el-button
          v-if="status < 3"
          size="large"
          type="danger"
          @click="displayDeleteDialog = true"
        >
          削除
        </el-button>
      </ScreenPermissionGate>
    </template>
    <template v-if="loadingFlag" #main>
      <div class="accept-detail-table-area">
        <div class="accept-detail-table-line">
          <div class="table-title">基本情報</div>
          <BaseDataTable
            :table-data="basicData"
            table-size="small"
            :label-width="125"
          />
        </div>
        <div class="accept-detail-table-line">
          <div class="table-title">発送製品情報</div>
          <el-table
            :data="productData"
            stripe
            border
            style="margin: 0px auto 10px"
            class="accept-detail-product"
            empty-text="製品が存在しません"
            size="small"
          >
            <el-table-column prop="productName" label="製品名" align="center">
              <template #default="scope">
                {{ productNameChanger[scope.row.productId].name }}
              </template>
            </el-table-column>
            <el-table-column
              prop="productPrice"
              label="価格"
              width="70px"
              align="center"
            />
            <el-table-column
              prop="productQty"
              label="数"
              width="40px"
              align="center"
            />
          </el-table>
          <div v-if="displayCarInfo" class="table-title">取付車両情報</div>
          <BaseDataTable
            v-if="displayCarInfo"
            :table-data="carData"
            table-size="small"
            :label-width="125"
          />
          <el-label v-if="harnessData.length >= 2" class="warning-label">
            ※要適合確認
          </el-label>
          <ScreenPermissionGate code="ACCEPT-BTN_COMPATIBILITY_CHECK">
            <el-button
              v-if="status === 2 && isShip"
              size="small"
              type="warning"
              @click="displayHarnessDialog = true"
            >
              適合確認
            </el-button>
          </ScreenPermissionGate>
        </div>
        <div class="accept-detail-table-line">
          <div class="table-title">取付先/発送先情報</div>
          <BaseDataTable
            :table-data="shipmentData"
            table-size="small"
            :label-width="120"
          />
        </div>
        <div class="accept-detail-table-line">
          <div class="table-title">その他/備考</div>
          <BaseDataTable
            :table-data="noteData"
            table-size="small"
            :label-width="95"
          />
          <div class="table-title">入力情報</div>
          <BaseDataTable
            :table-data="otherData"
            table-size="small"
            :label-width="85"
          />
          <div class="table-title">SF情報</div>
          <el-table
            :data="sfData"
            style="margin: 0px auto 10px"
            class="accept-detail-sf"
            empty-text="SF情報が存在しません"
            size="small"
          >
            <el-table-column prop="label" label="項目" width="120px" />
            <el-table-column prop="value" label="リンク">
              <template #default="scope">
                <a :href="scope.row.link" target="_blank">{{
                  scope.row.value
                }}</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-dialog v-model="displayDialog" title="出荷依頼" width="400px">
        <div class="accept-duplicate-vin-text" v-if="duplicateVIN">
          <div><b>車台番号が重複しています。</b></div>
          <div><b>そのまま、この受注情報で出荷依頼しますか？</b></div>
          <div class="accept-duplicate-vin-checkbox">
            <el-checkbox
              v-model="duplicatedVinConfirmed"
              label="上記を確認しました。"
            />
          </div>
        </div>
        <span v-else>
          <b>この受注情報で出荷依頼しますがよろしいですか？</b>
        </span>
        <template #footer>
          <el-button size="large" @click="displayDialog = false">
            キャンセル
          </el-button>
          <el-button
            :disabled="duplicateVIN && !duplicatedVinConfirmed"
            size="large"
            type="primary"
            @click="shipRequest"
          >
            実行
          </el-button>
        </template>
      </el-dialog>
      <el-dialog
        v-model="displayConfirmDialog"
        title="出荷依頼確定"
        width="400px"
      >
        <span>
          <b>この受注情報で出荷依頼を確定しますがよろしいですか？</b>
        </span>
        <template #footer>
          <el-button size="large" @click="displayConfirmDialog = false">
            キャンセル
          </el-button>
          <el-button size="large" type="danger" @click="shipRequestCancel">
            差し戻し
          </el-button>
          <el-button size="large" type="primary" @click="shipRequestConfirm">
            実行
          </el-button>
        </template>
      </el-dialog>
      <el-dialog
        v-model="displayDeleteDialog"
        title="受注情報削除"
        width="400px"
      >
        <span>
          <b>この受注情報を削除しますがよろしいですか？</b>
        </span>
        <template #footer>
          <el-button size="large" @click="displayDeleteDialog = false">
            キャンセル
          </el-button>
          <el-button size="large" type="danger" @click="deleteAccept">
            実行
          </el-button>
        </template>
      </el-dialog>
      <el-dialog
        v-model="displayHarnessDialog"
        title="ハーネス適合"
        width="780px"
      >
        <el-table :data="harnessData" style="width: 100%" border>
          <!-- 列の定義 -->
          <el-table-column prop="carModelCode" label="指定番号" width="90" />
          <el-table-column prop="carModelType" label="モデル区分" width="200" />
          <el-table-column prop="carModelYear" label="年式" width="80" />
          <el-table-column prop="carEndSales" label="終了" width="80" />
          <el-table-column prop="matchKinds" label="適合区分" width="90" />
          <el-table-column label="適合判定" width="90">
            <template #default="scope">
              {{ compatibility[scope.row.compatibilityResultJudge] }}
            </template>
          </el-table-column>
          <el-table-column prop="itemName" label="ハーネス" />
        </el-table>

        <template #footer>
          <el-button size="large" @click="displayHarnessDialog = false">
            閉じる
          </el-button>
        </template>
      </el-dialog>
    </template>
  </BaseSimpleLayout>
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import router from '@/router';
  import BaseSimpleLayout from '@/components/BaseSimpleLayout.vue';
  import BaseDataTable from '@/components/BaseDataTable.vue';
  import ScreenPermissionGate from '@/components/ScreenPermissionGate.vue';
  import {
    createBasicTableData,
    createCarTableData,
    createShipmentTableData,
    depotName
  } from '@/libs/accept';
  import { AcceptDetailsElement } from '@/types/accept';
  import { DetailTableData } from '@/types/common';
  import { ProductReplaceData } from '@/types/master/product';
  import { acceptStatus } from '@/libs/accept';
  import { formatDate, formatDateTime } from '@/libs/dateFormat';
  import { ElLoading } from 'element-plus';
  import { HarnessesDataState } from '@/types/master/harness';
  import { compatibility } from '@/libs/harness';
  import { ManagementListState } from '@/types/management';

  const props = defineProps({
    acceptId: {
      type: String,
      required: true
    }
  });
  const store = useStore();
  const basicData = ref<DetailTableData[]>([]);
  const carData = ref<DetailTableData[]>([]);
  const productData = ref<AcceptDetailsElement[]>([]);
  const shipmentData = ref<DetailTableData[]>([]);
  const noteData = ref<DetailTableData[]>([]);
  const otherData = ref<DetailTableData[]>([]);
  const productNameChanger = ref<ProductReplaceData>({});
  const harnessData = ref<HarnessesDataState[]>([]);
  const status = ref(0);
  const isShip = ref(false);
  const displayCarInfo = ref(false);
  const loadingFlag = ref(false);
  const displayDialog = ref(false);
  const displayConfirmDialog = ref(false);
  const displayDeleteDialog = ref(false);
  const displayHarnessDialog = ref(false);
  const duplicateVIN = ref(false);
  const duplicatedVinConfirmed = ref(false);
  const customerId = ref<string | null>(null);
  const sfData = computed(() => {
    const data: DetailTableData[] = [];
    try {
      const parsedData = JSON.parse(store.state.accept.detailData.sfOrderCode);
      if (parsedData.opportunityId) {
        data.push({
          label: '商談',
          value: parsedData.opportunityId,
          link: `https://gmsjp.lightning.force.com/lightning/r/Opportunity/${parsedData.opportunityId}/view`
        });
      }
      if (parsedData.salesforceId) {
        data.push({
          label: 'MCCS取付',
          value: parsedData.salesforceId,
          link: `https://gmsjp.lightning.force.com/lightning/r/Opportunity/${parsedData.salesforceId}/view`
        });
      }
    } catch (error) {
      // sfOrderCodeがJSON形式ではない場合何もしない
    }
    return data;
  });
  const initialize = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true });
    await Promise.all([
      store.dispatch('productsMaster/fetch'),
      store.dispatch('supportShopsMaster/fetch'),
      store.dispatch('businessTypesMaster/fetch'),
      store.dispatch('accept/fetchDetail', props.acceptId)
    ]);
    const detailData = store.state.accept.detailData;
    const businessTypeLabels = store.state.businessTypesMaster.replaceData;
    const supportShopChanger = store.state.supportShopsMaster.replaceData;
    productNameChanger.value = store.state.productsMaster.replaceData;
    if (!detailData) return router.push('/accept');
    status.value = detailData.status;
    isShip.value = detailData.isShip;
    basicData.value = createBasicTableData(detailData, businessTypeLabels);
    basicData.value[6].value = detailData.financeName;
    basicData.value[10].value = detailData.shopName;
    basicData.value[9].value = detailData.companyName;
    basicData.value[8].value = detailData.companyGroupName;
    basicData.value[15].value = detailData.orderCompanyName
      ? detailData.orderCompanyName
      : '-';
    basicData.value.unshift({
      label: 'ステータス',
      value: acceptStatus(detailData.status, detailData.isRemand)
    });
    if (detailData.type === 1 && detailData.isShip) {
      carData.value = createCarTableData(detailData);
      carData.value[2].value = detailData.carMakerName;
      displayCarInfo.value = true;
    }
    carData.value.push({
      label: 'ハーネス品番',
      value: detailData.harnessPartCode ? detailData.harnessPartCode : '-'
    });
    carData.value.push({
      label: 'ハーネス名称',
      value: detailData.harnessName ? detailData.harnessName : '-'
    });
    try {
      await store.dispatch('harnessesMaster/fetchFilter', {
        deviceType: detailData.harnessType,
        carModel: detailData.carModel,
        ignitionType: detailData.ignitionType
      });
    } catch (error) {
      console.error('Error fetching filter2:', error);
    }

    harnessData.value = store.state.harnessesMaster.listData;

    carData.value.push({
      label: 'ハーネス適合数',
      value: harnessData.value.length
    });

    productData.value = detailData.details;
    shipmentData.value = createShipmentTableData(detailData);
    customerId.value = store.state.management.customerId;
    if (detailData.supportShopId) {
      shipmentData.value[1].value =
        supportShopChanger[detailData.supportShopId];
    } else {
      shipmentData.value[1].value = basicData.value[10].value;
    }
    noteData.value = [
      {
        label: '拠点',
        value: depotName[detailData.depotId]
      },
      {
        label: '着指定日',
        value: detailData.arrivalDate
          ? formatDate(Number(detailData.arrivalDate))
          : '-'
      },
      {
        label: '東京専用\r\n備考',
        value: detailData.note
      },
      {
        label: '発送時連携\r\n用備考',
        value: detailData.shipNote
      }
    ];
    otherData.value = [
      {
        label: '作成日時',
        value: formatDateTime(Number(detailData.createdAt))
      },
      {
        label: '作成者',
        value: detailData.registerUserName
      },
      {
        label: '更新日時',
        value: formatDateTime(Number(detailData.updatedAt))
      },
      {
        label: '更新者',
        value: detailData.updateUserName
      }
    ];
    loadingInstance.close();
    loadingFlag.value = true;
  };

  const handleShipRequestClick = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true });
    const detailData = store.state.accept.detailData;

    await store.dispatch('management/fetch');
    const isDuplicate = store.state.management.listData.findIndex(
      (data: ManagementListState) => {
        return data.vin === detailData.vin;
      }
    );
    loadingInstance.close();
    if (isDuplicate >= 0) {
      duplicateVIN.value = true;
    }
    displayDialog.value = true;
  };

  const shipRequest = async () => {
    if (duplicateVIN.value && !duplicatedVinConfirmed.value) {
      return;
    }
    await store.dispatch('accept/request', {
      acceptId: props.acceptId,
      processType: 1
    });
  };

  const shipRequestConfirm = async () => {
    await store.dispatch('accept/request', {
      acceptId: props.acceptId,
      processType: 2
    });
  };

  const shipRequestCancel = async () => {
    await store.dispatch('accept/request', {
      acceptId: props.acceptId,
      processType: 9
    });
  };

  const deleteAccept = async () => {
    await store.dispatch('accept/delete', props.acceptId);
  };

  const backCustomerDetail = () => {
    router.push('/management/' + customerId.value);
  };
  initialize();
</script>
<style lang="scss">
  .accept-detail {
    .base-data-table {
      width: 330px;
      margin: 0px auto;
    }
    .main-container {
      width: 98%;
      margin-top: 5px;
    }
    .table-title {
      font-size: 18px;
      font-weight: 600;
    }
    .accept-detail-table-area {
      width: 1410px;
      .accept-detail-table-line {
        width: 330px;
        margin-left: 10px;
        float: left;
      }
    }
    .accept-detail-button-area {
      clear: left;
      margin: 20px 0px;
    }
    .accept-detail-product {
      .cell {
        font-size: 14px;
        font-weight: 600;
      }
    }
    .el-button {
      font-weight: 600;
    }
    .el-table {
      thead {
        th {
          background: #f5f7fa;
        }
      }
    }
    .warning-label {
      margin-left: 100px;
      margin-right: 10px;
      font-size: 14px;
      font-weight: 600;
      color: red;
    }
    .accept-duplicate-vin-text {
      color: #f56c6c;
    }
    .accept-duplicate-vin-checkbox {
      width: 100%;
      margin-top: 10px;
    }
  }
</style>
